var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#1EA1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9532 12.2172C23.9612 12.4019 23.9652 12.5851 23.9652 12.7683C23.9652 18.4154 19.8383 24.9231 12.2898 24.9231C9.97093 24.9231 7.81479 24.2165 6 23.0033C6.32135 23.0435 6.64804 23.0616 6.98007 23.0616C8.90419 23.0616 10.6723 22.38 12.0751 21.232C10.279 21.1973 8.76285 19.9618 8.24148 18.2655C8.49217 18.3154 8.74952 18.3418 9.01353 18.3418C9.38823 18.3418 9.75225 18.2891 10.0949 18.1919C8.21748 17.8004 6.80272 16.0735 6.80272 14.0038C6.80272 13.9858 6.80272 13.9677 6.80272 13.9497C7.35609 14.2703 7.98813 14.4619 8.66151 14.4841C7.56144 13.7192 6.83606 12.4102 6.83606 10.929C6.83606 10.1447 7.0374 9.41037 7.39076 8.78153C9.41489 11.3663 12.4391 13.0682 15.8487 13.2459C15.7793 12.9335 15.7433 12.6073 15.7433 12.2728C15.7433 9.91427 17.5808 8 19.8463 8C21.0263 8 22.0931 8.51917 22.8411 9.34929C23.7759 9.15634 24.6546 8.80236 25.448 8.31234C25.1413 9.31042 24.4906 10.1461 23.6425 10.6764C24.4719 10.5737 25.2626 10.3446 26 10.0045C25.452 10.8624 24.7572 11.6134 23.9532 12.2172Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7876764826f19d79d4098c4f3c9683f6.svg";
export { ForwardRef as ReactComponent };